<template> 
  <div> 
    <div class="d-flex flex-stack flex-wrap">
        <div class="page-title d-flex flex-column me-3 mt-3"> 
            <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('update_fixed_asset_account') }}</h1>  
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary">
                        <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                    </a>
                </li> 
                <li class="breadcrumb-item text-primary">{{ $t('accounts') }}</li>     
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'FixedAssetList' }">{{ $t('fixed_asset') }}</router-link></li>     
                <li class="breadcrumb-item text-gray-600">{{ $t('update_fixed_asset_account') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                </li> 
            </ul> 
        </div>  
        <div class="d-flex align-items-center py-1">
            <router-link to="/FixedAssetList">
                <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                <span class="ms-2 fs-7"> {{ $t('return_back_to_list') }}</span>
                </button>
            </router-link> 
            &nbsp;
            <div class="dropdown" v-if="this.$isCredentialActive(17,'D')">
                <button class="btn btn-light-info border border-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="true" id="assetActions" type="button">
                <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor"/>
                <path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor"/>
                </svg></span>
                    {{ $t('actions') }}
                </button>
                <ul class="dropdown-menu" aria-labelledby="assetActions"> 
                    <li>
                        <a class="dropdown-item fs-4 text-danger" href="#" @click="deleteItem()"><span class="svg-icon svg-icon-muted svg-icon-2 text-danger"><svg width="24" height="24" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"/>
                        <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"/>
                        <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"/>
                        </svg>
                        </span>{{ $t('delete') }} </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
        <div class="content flex-row-fluid mt-4" id="kt_content"> 
            <StatsBar :form-account="this.form"></StatsBar>
            <div class="card-body">
                <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': this.activeTab == 'Account'}" data-bs-toggle="tab" href="#kt_accounting_1" target="_self"
                        @click="this.activeTab = 'Account'">
                            <h4> {{ $t('fixed_asset_account') }} </h4>
                        </a>
                    </li>
                    <li class="nav-item" v-if="this.$isModuleActive(3)">
                        <a class="nav-link" :class="{'active': this.activeTab == 'Documents'}" data-bs-toggle="tab" href="#kt_accounting_4" target="_self"
                        @click="activateDocumentsSection()">
                            <h4> {{ $t('documents') }} </h4>
                        </a>
                    </li>
                </ul>
            </div>
            <RequiredField></RequiredField>
            <div class="tab-content" id="myTabContent">
            <div class="card card-xxl-stretch tab-pane fade show active" id="kt_accounting_1" role="tabpanel"> 
                <form id="poliform" @submit.prevent="" class="form fv-plugins-bootstrap5 fv-plugins-framework">
                    <div class="d-flex flex-row row p-10">
                        <div class="d-flex flex-column flex-row-auto col-lg-6">
                            <div class="d-flex flex-column-fluid card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                <div class="card-body pb-0"> 
                                    <div class="fv-row mb-7 row">
                                        <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'asset_name'">
                                                {{ $t('asset_name') }}
                                            </label>
                                            <input type="text" class="form-control" name="asset_name" v-model="form.name" v-custom>
                                        </div>
                                        <div class="col-lg-12" v-if="isViewAccountId">
                                            <label class="fs-6 fw-bold form-label mt-3" :class="{'required': isViewAccountId}">
                                                {{ $t('asset_serial_no') }}
                                            </label>
                                            <input type="text" class="form-control" name="accountID" v-model="form.account_id">
                                        </div>
                                        <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'asset_type'">
                                                <span>{{ $t('asset_type') }}</span>
                                            </label>
                                            <Select2 v-model="form.asset_type_id" :options="assetTypeList" name="asset_type" v-custom :settings="{ width: '100%'}"/> 
                                        </div>  
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column flex-row-auto col-lg-6">
                            <div class="d-flex flex-column-fluid card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                <div class="card-body pb-0"> 
                                    <div class="fv-row  row">
                                        <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'branch'">
                                                <span>{{ $t('branch') }}</span>
                                            </label>
                                            <Select2 v-model="form.branch_id" :options="branchList" name="branch" v-custom :settings="{ width: '100%'}"/> 
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="fv-row mb-7">
                                                <label class="fs-6 fw-bold form-label mt-3" v-tag="'expense_center'">
                                                    <span>{{ $t('expense_center') }}</span>
                                                </label>
                                                <Select2 v-model="form.expense_center_id" :options="expenseCenterList" name="expense_center" v-custom :settings="{ width: '100%'}"/> 
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                <div class="card-body">
                                    <div class="fv-row  row">
                                        <div class="col-lg-6">
                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'economic_life'">
                                                <span>{{ $t('economic_life') }}({{ $t('year') }})</span>
                                            </label>
                                            <input type="number" class="form-control" name="economic_life" v-model="form.economic_life" @blur="onChangeEconomicLife()" v-custom>                                        
                                        </div>     
                                        <div class="col-lg-6">
                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'amortization_rate'">
                                                <span>{{ $t('amortization_rate') }}</span>
                                            </label>
                                            <CurrencyInput type="text" step="any" class="form-control text-end" v-model="form.amortization_rate" 
                                                name="amortization_rate" v-custom @focus="$event.target.select()" @blur="onChangeEconomicLife()"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                <div class="card-body pb-0"> 
                                    <div class="fv-row mb-7">
                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'notes'">
                                            <span>{{ $t('notes') }}</span>
                                        </label>
                                        <textarea class="form-control" name="notes" v-model="form.notes" v-custom></textarea>
                                    </div>
                                    <div class="fv-row mb-7">
                                        <div class="col-lg-4">
                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'show_on_invoice'">
                                                <span>{{ $t('show_on_invoice') }}</span>
                                            </label>
                                            <Select2 v-model="form.is_show_invoice" :options="showInvoiceList" name="show_on_invoice" v-custom :settings="{ width: '100%'}"/> 
                                        </div>
                                    </div>      
                                </div>
                            </div>                    
                        </div>
                        <div class="col-lg-12 mt-0" v-if="this.$isCredentialActive(17,'U')">
                            <div class="d-grid gap-2"> 
                                <button type="button" class="btn btn-lg btn-primary mb-0" @click="this.saveData()" data-kt-indicator="on">
                                    <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                    <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                    </svg>
                                    </span>
                                    <strong v-if="!this.isProgressing"> {{ $t('update_fixed_asset_account') }} </strong> 
                                        <span class="indicator-progress" v-if="this.isProgressing">
                                            {{ $t('saving_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span> 
                                </button>
                            </div>
                        </div>
                            
                    </div>
                </form>
            </div>
            <div class="card card-xxl-stretch tab-pane fade" id="kt_accounting_4" role="tabpanel">
                <div class="row p-10" v-if="this.activeTab == 'Documents'">
                            <FileManager :location="1" :locationtype="8" :upload_source="4" ref="FileManagerComponent"></FileManager>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"; 

 
export default {
  name: "FixedAssetUpdate",
  data() {
    return { 
      userData: this.$getUser(),
      assetTypeList: [],
      branchList: [],
      expenseCenterList: [],
      showInvoiceList: [ {id: '1', text: this.$t('yes')}, {id: '0', text: this.$t('no')}],
      isProgressing: false,
      form: {
        id: null,
        name: null,
        company_id: null,
        account_type: null,
        account_id: null,
        qr_code: null,
        notes: null,
        asset_type_id: '-1',
        branch_id: '-1',
        expense_center_id: '-1',
        accounting_plan: null,
        is_show_invoice: 1,
        economic_life: 1,
        amortization_rate: 100
      },
      isViewAccountId: false,
      activeTab: 'Account',
      menuSelection: '/FixedAssetHelppage',
      iconView : false,
      lists: []
    };
  },
  methods: {
    getData() {
        this.$Progress.start();
        const params = {
            id: this.$getSessionStorage('record_id'),
            session_id: this.$getUser().session_id
        };
        axios.post('api/CompanyAccounts/GetAccountById', params, {'Content-Type': 'application/json'})
        .then((response) => {             
            this.form.id = response.data.id;
            this.form.name = this.$unlock(response.data.name);
            this.form.account_type = response.data.account_type;
            this.form.account_id = this.$unlock(response.data.account_id);
            this.form.qr_code = this.$unlock(response.data.qr_code);
            this.form.notes = response.data.notes;
            this.form.asset_type_id = (response.data.fixed_asset_asset_type_id == '' || response.data.fixed_asset_asset_type_id == null) ? '-1': response.data.fixed_asset_asset_type_id;
            this.form.branch_id = (response.data.branch_id == null || response.data.branch_id == '') ? '-1': response.data.branch_id;
            this.form.expense_center_id = (response.data.expense_center_id == null || response.data.expense_center_id == '') ? '-1': response.data.expense_center_id;
            this.form.is_show_invoice = response.data.is_show_invoice;
            this.form.economic_life = response.data.fixed_asset_economic_life;
            this.form.amortization_rate = response.data.fixed_asset_amortization_rate;
 
            this.getLists();
        })
        .catch((error) => {
            console.error(error);
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");   
        });
    },
    getLists() {
        const params = {
            session_id: this.$getUser().session_id,
            list_type: 8, // Asset Type: 8
            get_access_status: 0
            
        };
        axios.post("/api/Helper/GetLists", params, {'Content-Type': 'application/json'}).then((response) => { 
            this.assetTypeList = response.data; 
            this.assetTypeList.unshift({ id: '-1', text: this.$t('select_an_option')});
            const parameters = { 
                session_id: this.$getUser().session_id,
                list_name: ["branch", "account_setting", "expense_center"],
                account_type: 8 // yalnızca account settings listesi çekilecek ise gerekli
            }; 
            axios.post('/api/Helper/GeneralLists', parameters, {'Content-Type': 'application/json'}).then((response) => {                
                this.branchList = response.data.branch;
                this.expenseCenterList = response.data.expense_center;
                if (response.data.account_setting.is_default == false) {
                    this.isViewAccountId = true;
                }
                this.$Progress.finish();
            })
            .catch((error) => {
                console.error(error);
                this.$Progress.finish();
            });
        })
        .catch((error) => {
            console.error(error);
            this.$Progress.finish();
        });
    },
    async helpPageViewIcon()
    {
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/FixedAssetHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
    }, 
    saveData(){
        this.$checkSelect2Validation('poliform');
        if(!document.forms['poliform'].reportValidity()){
            return;
        }
        this.isProgressing = true;
        const params = {
            id:this.form.id,
            name:this.form.name,
            company_id:this.form.company_id,
            account_type:this.form.account_type,
            account_id:this.form.account_id,
            qr_code:this.form.qr_code,
            notes:this.form.notes,
            asset_type_id:this.form.asset_type_id == '-1' ? null : this.form.asset_type_id,
            branch_id:this.form.branch_id == '-1' ? null : this.form.branch_id,
            expense_center_id:this.form.expense_center_id == '-1' ? null : this.form.expense_center_id,
            accounting_plan:this.form.accounting_plan,
            is_show_invoice:this.form.is_show_invoice,
            economic_life:this.form.economic_life,
            amortization_rate:this.form.amortization_rate
        };    
        const that = this;
        params.session_id = this.$getUser().session_id;
        if(params.branch_id == '-1'){ params.branch_id = null;}
        if(params.expense_center_id == '-1'){ params.expense_center_id = null;}
        if(params.asset_type_id == '-1'){ params.asset_type_id = null;}
        axios.post('api/CompanyAccounts/UpdateAccount', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(response.data != null && response.data.length == 36){  
                this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');  
            }
        })
        .catch(() => { 
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), 'error');
        })
        .finally(() => { 
            setTimeout(() => {
                that.isProgressing = false;
            }, 500);
        }); 
    },
    deleteItem(){
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_delete_this_data'),
            confirmButtonColor: '#f1416c',
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('yes'),
            icon: 'warning'
          }).then((result) => { 
            if (result.isConfirmed) {
            const params = {
                session_id: this.$getUser().session_id,
                id: this.form.id
            }; 
            axios.post('api/CompanyAccounts/DeleteAccount', params, {'Content-Type': 'application/json'})
                .then((response) => { 
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                        this.$router.push({ name: 'FixedAssetList' });
                    }
                })
                .catch(() => { 
                    this.$swal(this.$t('failed'), this.$t('data_could_not_be_deletedplease'), 'error');   
                });  
            }
          })   
    },
    activateDocumentsSection(){
        this.activeTab = 'Documents'; 
    },
    onChangeEconomicLife() {
        this.form.amortization_rate = 100 / this.form.economic_life;
    }
  },
  created() {
    this.helpPageViewIcon();
    this.getData();
  },
};
</script>